import { customFetch } from '#/services/customFetch'
import type { Course } from '../types/course.types'

export async function getCourseBySlug(slug: string): Promise<Course> {
  return customFetch<Course>(`/student/courses/${encodeURIComponent(slug)}`)
}
